import React, { useState, useEffect, useCallback } from "react";
import { Card, message, Flex } from "antd";
import orderService from "../../services/OrderLists";
import SolutionMetaFilters from "./SolutionMetaFilters";
import SolutionMetaTable from "./SolutionMetaTable";
import { Button } from "antd";

const SolutionMeta = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 15,
        total: 0,
    });
    const [filters, setFilters] = useState({});
    const [filtersList, setFiltersList] = useState([]);
    const [filtersData, setFiltersData] = useState({});

    const fetchData = useCallback(async (page = 1, pageSize = 15, currentFilters = {}) => {
        setLoading(true);
        try {
            const response = await orderService.getSolutionMetaList(page, pageSize, currentFilters);

            if (response.success) {
                const apiData = response.data?.data || response.data;
                const results = apiData?.results || [];
                const count = apiData?.count || 0;
                const availableFilters = apiData?.filters || [];
                const availableFiltersData = apiData?.filters_data || {};

                setData(results);
                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize: pageSize,
                    total: count,
                }));
                setFiltersList(availableFilters);
                setFiltersData(availableFiltersData);
            } else {
                message.error("Failed to fetch Solutions Meta list");
            }
        } catch (error) {
            console.error("Error fetching Solutions Meta list:", error);
            message.error("An error occurred while fetching Solutions Meta list");
        } finally {
            setLoading(false);
        }
    }, []);

    const { current, pageSize } = pagination;
    useEffect(() => {
        fetchData(current, pageSize, filters);
    }, [current, pageSize, filters, fetchData]);

    const handleSearch = (newFilters) => {
        setFilters(newFilters);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };


    const handleDownload = async () => {
        try {
            message.loading({ content: "Preparing CSV...", key: "csv" });

            await orderService.downloadSolutionMetaCSV(filters);

            message.success({ content: "CSV downloaded", key: "csv" });
        } catch (error) {
            console.error("CSV download failed:", error);
            message.error({ content: "Failed to download CSV", key: "csv" });
        }
    };


    return (
        <div style={{ padding: "10px", width: "100%" }}>
            <SolutionMetaFilters
                onSearch={handleSearch}
                onReset={() => handleSearch({})}
                filtersList={filtersList}
                filtersData={filtersData}
                loading={loading}
                filters={filters}
            />
            <Flex justify="space-between" align="center" style={{ width: "100%" }}>
                {!loading && (
                    <p style={{ margin: 0 }}>
                        Showing{" "}
                        {Math.min(
                            (pagination.current - 1) * pagination.pageSize + 1,
                            pagination.total
                        )}{" "}
                        -{" "}
                        {Math.min(
                            pagination.current * pagination.pageSize,
                            pagination.total
                        )}{" "}
                        of {pagination.total} Orders.
                    </p>
                )}

                <Button
                style={{backgroundColor:"#040724",border:"none",color:"white",marginBottom:"10px"}}
               
                    onClick={handleDownload}
                    disabled={loading || pagination.total === 0}
                >
                    Download CSV
                </Button>
            </Flex>
            <Card style={{ width: "100%" }} bodyStyle={{ padding: 0 }}>

                <SolutionMetaTable

                    data={data}
                    loading={loading}
                    pagination={pagination}
                    setPagination={setPagination}
                    onRefresh={() => fetchData(pagination.current, pagination.pageSize, filters)}
                />
            </Card>
        </div>
    );
};

export default SolutionMeta;
